import axios from 'axios';
import Cookies from 'js-cookie';
import qs from 'qs'

const baseURL = 'http://120.25.206.0:8080';
//var _openId = Cookies.get("openId");
var _openId = localStorage.getItem('openId');
var _setheaders = () => {
    axios.defaults.baseURL = _baseurl();
    axios.defaults.headers.post['Content-Type'] = 'application/json';
    axios.defaults.headers.common['openid'] = localStorage.getItem('openId');
}

var _baseurl = () => {
    var _url = '';
    if (process.env.NODE_ENV != "development") {
        _url = "/wxapi"
    } else {
        _url = "/wxapi"
    }
    return _url
}

var _setbaseurl = (url) => {
    var _whiteUrls = {
        '/oauth/token': '/wxapi',
        '/uaa/oauth/token': '/wxapi'
    };
    if (_whiteUrls[url] == undefined) {
        //url = "/sys" + url;
    }
    // /console.log(url)
    if (url == '/opt/custacc/getCust' || url.indexOf('/opt/custacc/getConfig') >= 0) {
        if (process.env.NODE_ENV != "development") {
            axios.defaults.baseURL = 'http://120.25.206.0:8080';
        } else {
            axios.defaults.baseURL = '/api1';
        }
    } else {
        axios.defaults.baseURL = _baseurl();
    }
    //console.log('axios.defaults.baseURL: ', axios.defaults.baseURL)
    return url;
}

// 添加一个响应拦截器
axios.interceptors.response.use((response) => {
    //console.log('response', response);
    if (response) {
        var _url = response.config.url;
        if (_url && _url.indexOf('getUserByEmpIDNum/') >= 0) {
            //response.data.status = 200;
        }
    }
    if (response && response.data.status > 400) {
        //response.data.message = response.data.error?response.data.error:response.data.message ;//+ " " + response.data.error
        return Promise.reject(response.data);
    } else {
        return response;
    }

}, function (err) {
    //console.log('responseErr', err.response);
    if (err && err.response) {
        switch (err.response.status) {
            case 400:
                err.message = '请求错误'
                break

            case 401:
                err.message = '未授权，请登录'
                break

            case 403:
                err.message = '拒绝访问'
                break

            case 404:
                err.message = `请求地址出错: ` + err.response.config.url
                break

            case 408:
                err.message = '请求超时'
                break

            case 500:
                err.message = '服务器内部错误'
                break

            case 501:
                err.message = '服务未实现'
                break

            case 502:
                err.message = '网关错误'
                break

            case 503:
                err.message = '服务不可用'
                break

            case 504:
                err.message = '网关超时'
                break

            case 505:
                err.message = 'HTTP版本不受支持'
                break
        }
        err.status = err.response.status;
        return Promise.reject(err);
    }
});

var _setIfAuth = (url) => {
    var _openId = localStorage.getItem('openId'),//Cookies.get("openId"),
        _accountNo = Cookies.get("accountNo");

    // 获取openid
    if (url.indexOf('get-openid') > 0 && (_openId == undefined || _openId === '')) {
        return Promise.resolve({ ret_code: '000100' })
    } else if ((_openId != undefined && _openId !== '') && (_accountNo == undefined || _accountNo === '')) {
        return Promise.resolve({ ret_code: '000100' })
    } else if (_openId && _accountNo) {
        return Promise.resolve({ ret_code: '000100' })
    } else if (_openId==undefined) {
        return Promise.resolve({ ret_code: '000000' })//, ret_msg:"获取code值失败！"
    }
    //console.log(url,_openId , _accountNo)
}

var _getWxCode = ()=>{
    // console.log('_getWxCode=>location.host',location.host);
    //debugger
    if(location.host.indexOf('192.168')>=0||location.host.indexOf('localhost')>=0){
        console.log('_getWxCode',false)
        return false;
    }
    console.log('fetCode=>location=>host: ', location.host);
    //报redirect_uri参数错误时，注意是不是appid不对
    if(location.host.indexOf('yuansfer.yunkeguan.com')>=0 || location.host.indexOf('127.0.0.1')>=0 ){
        // 以下是测试环境调用code
        window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx48dd3ab0e2858ddc&redirect_uri=https%3a%2f%2fwx.yuansfer.yunkeguan.com%2f%23%2flogin&response_type=code&scope=snsapi_base&state=123#wechat_redirect"
    }else{
        //以下是生产环境中调用code
        window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfe379af76a591a6f&redirect_uri=https%3a%2f%2fwx.yuansfer.com%2f%23%2flogin&response_type=code&scope=snsapi_base&state=123#wechat_redirect"
    }
}

let ajax = {

};
ajax.ajaxUrlPart = ""; //原本
//test
// ajax.ajaxUrlPart = "http://127.0.0.1:8020/wxapi";
// ajax.test = (url, params, config) => {
//     console.log("ajax test")
// }
ajax.post = (url, params, config) => {
    _setheaders();
    //console.log('post',url,params)
    return new Promise((resolve, reject) => {
        _setIfAuth(url).then((result) => {
            //console.log(result)
            if (result.ret_code == '000100') {
                //console.log('openId',localStorage.getItem('openId'));
                axios.post(_setbaseurl(url), params, config)
                    .then(response => {
                        if(response.data&&response.data.openId){
                            _openId = response.data.openId;
                            localStorage.setItem('openId',_openId);
                            axios.defaults.headers.common['openid'] = _openId;
                        }
                        response.data ? resolve(response.data) : resolve(response)
                    }).catch((err) => {
                    reject({ message: err.message, status: err.status });
                })
            } else {
                resolve(result);
            }
        })
    })
};

ajax.get = (url, config) => {
    _setheaders();
    return new Promise((resolve, reject) => {
        _setIfAuth(url).then((result) => {
            console.log(url, result)
            if (result.ret_code == '000100') {
                axios.get(_setbaseurl(url), config)
                    .then(response => {
                        resolve(response.data)
                    })
                    .catch((err) => {
                        reject({ message: err.message, status: err.status });
                    })
            } else {
                reject(result);
            }
        })
    })
}

ajax.upload = (url, params, config) => {
    _setheaders();
    return new Promise((resolve, reject) => {
        axios.post(url, qs.stringify(params), config)
            .then(response => {
                response.data ? resolve(response.data) : resolve(response)
            }).catch((err) => {
            reject({ message: err.message, status: err.status });
        })
    })
};

//000200
// ajax.handleIfLogin = function(vm, result) {
//     if(result&&result.ret_code=='000200'){
//         vm.$router.push({name:"login"})
//     }
// }
//then 返回结果处理
ajax.handleAjaxResult = (vm, result) => {
    console.log('handleAjaxResult');
    // console.log('vm:', vm);
    // console.log('result:', result);
    setTimeout(()=>{
        vm.$Indicator.close();
    },500)
    if (result && result.ret_code == '000200') {
        localStorage.removeItem('openId')
        _getWxCode();
        result.ret_msg = "请重新登录！"
    }
    if (result.ret_code == '000100' && result.ret_msg) {
        // 20190923 解除注释
        vm.$Toast({
            message: result.ret_msg,
            iconClass: 'iconfont icon-success',
            position: 'center',
            duration: 2000
        })
    } else if (result.ret_code !== '000100' && result.ret_msg) {
        //console.log('handleAjaxResult', result);
        vm.$Toast({
            message: result.ret_msg,
            position: 'bottom',
            duration: 2000
        })
        if(
            result.ret_msg && (result.ret_msg.indexOf('Wechat Unsigned Yet')!==-1 || result.ret_msg.indexOf('重新登录')!==-1 || result.ret_msg.indexOf('登录失败')!==-1)
        ){
            console.log('I am jumpping');
            vm.$router.push({path: '/login'})
            // vm.jump('/login');
        }
    }
    //当登录，退出，关闭，重新进入微信页面的时候
    if(result && result.hasOwnProperty('openId')&&result.openId && !result.accountNo){
        console.log('登录，退出，关闭，重新进入jump');
        vm.$router.push({path: '/login'})
    }
    if(result.ret_code != '000100'&&result.ret_msg==undefined){
        //console.log(result,this.a)
        ajax.getOpenid(vm);
    }

}
//catch 报错提示
ajax.handleAjaxError = (vm, err) => {
    //vm.$store.state.loadingStatus = false;
    console.log('handleAjaxError:', err);
    setTimeout(()=>{
        vm.$Indicator.close();
    },500)
    if (err) {
        switch (err.status) {
            case 401:
                vm.jump('/login');
                break;
        }
        if (err.status > 200) {
            vm.$Toast({
                message: err.status + ' ' + err.message,
                position: 'center',
                duration: 4000
            })
        }
    }
}

ajax.logout = (vm) => {
    //使用openid作为logout凭证
    var _ajax = ajax;
    // console.log('ajax=>logout');
    // let tnpOpenid =  localStorage.getItem("openId");
    // console.log('tnpOpenid: ', tnpOpenid);
    ajax.post(ajax.ajaxUrlPart + 'wxoauser/logout', {
        openId: localStorage.getItem("openId"),
    }).then((result) => {
        console.log('logout=>result', result)
        _ajax.handleAjaxResult(vm, result);
        if (result.ret_code == '000100') {
            localStorage.removeItem('openId');
            localStorage.removeItem('accountNo'); // 20190924 add
            Cookies.remove("accountNo"); // 20190924 add
            Cookies.remove("code");
            _getWxCode()
        }
    }).catch(err => {
        _ajax.handleAjaxError(vm, err);
    })
}
ajax.getOpenid = (vm) => {
    //console.log('ajax.getOpenid');
    var _ajax = ajax,
        //_ifOpenid = Cookies.get("openId")==undefined||Cookies.get("openId")==='',
        _ifOpenid = localStorage.getItem("openId"),
        _ifCode = Cookies.get("code");
    //var _name = vm.$route.path.replace('/',''); //有什么用的?
    if(_ifOpenid==undefined&&_ifCode==undefined){
        //console.log('ajax.getOpenid=>1');
        console.log('I logout then close then enter again')
        _getWxCode()
    }
    _ifOpenid==undefined&&ajax.post(ajax.ajaxUrlPart + 'wxoauser/get-openid', {
        code: Cookies.get("code"),
    }).then((result) => {
        //用完code，删除 20190923
        Cookies.remove("code")
        //console.log('ajax.getOpenid=>2');
        if (result.accountNo) {
            Cookies.set("accountNo", result.accountNo);
        }
        if (result.ret_code == '000000') {
            if(result.ret_msg!=='登录失败'){
                result.ret_msg = "获取数据失败，请刷新页面重试！"
            }
            _ajax.handleAjaxResult(vm, result);
        }else if (result.ret_code == '000100') {
            // result.ret_msg = '';
        }
        if (result.ret_code == '000100') {
            // 是否绑定账号
            var _accountNo = Cookies.get("accountNo")
            if (_accountNo) {
                if(vm.$route.name!='login'){
                    vm.$router.push({ name: vm.$route.name });
                }
            }
        }else if (result.ret_code == '000201'){
            _getWxCode();
        }
    }).catch(err => {
        console.log('err: ', err);
        //用完code，删除 20190923
        Cookies.remove("code")
        _ajax.handleAjaxError(vm, err);
    })
}

export default ajax;



// WEBPACK FOOTER //
// ./src/libs/ajax.js